<template>
  <dialogWrap
    v-model="show"

    :title="title"
    :width="width"
    :before-close="cancelHandle"
  >
    <el-form
      v-if="isReject"
      class="mt16"
      :model="formData"
      :rules="rules"
      ref="approvalForm"
    >
      <el-form-item prop="remark" label="">
        <el-input
          type="textarea"
          :rows="2"
          maxlength="500"
          show-word-limit
          placeholder="请输入驳回原因"
          v-model="formData.remark"
        />
      </el-form-item>
    </el-form>

    <span v-else>{{ content }}</span>

    <template slot="footer">
      <el-button @click="cancelHandle" size="small">取消</el-button>
      <el-button
        :loading="confirmLoading"
        @click="confirmHandle"
        size="small"
        type="primary"
        >确认</el-button
      >
    </template>
  </dialogWrap>
</template>

<script>
import { approvalTaskSubmit } from '@/api/domain/approvals'

export default {
  name: 'ApprovalDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '确认驳回原因',
    },
    content: {
      type: String,
      default: '确定审批通过吗?',
    },
    width: {
      type: String,
      default: '400px',
    },
    approvalData: {
      type: Object,
      default() {
        return {}
      },
    },
    callbackFn: {
      type: Function,
      default: null,
    },
  },
  watch: {
    dialogVisible(val) {
      this.formData = {
        id: '',
        state: '',
        remark: '',
      }
      this.show = val
      if (val) this.confirmLoading = false
    },
  },
  computed: {
    isReject() {
      return this.approvalData && this.approvalData.state === 30
    },
  },
  data() {
    return {
      show: false,
      confirmLoading: false,
      formData: {
        id: '',
        state: '',
        remark: '',
      },
      rules: {
        remark: [
          { required: true, message: '请输入驳回原因', trigger: 'blur' },
          {
            min: 1,
            max: 500,
            message: '长度在 1 到 500 个字符',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    async approvalTaskSubmit() {
      if (this.confirmLoading) return
      this.confirmLoading = true
      try {
        const successMsg = this.isReject ? '驳回成功' : '审核通过'
        const params = Object.assign(this.formData, this.approvalData)
        const { code } = await approvalTaskSubmit(params)
        if (code !== 1) {
          this.confirmLoading = false
          return
        }
        this.$message.success(successMsg)
        this.cancelHandle()
        this.$emit('refreash')
      } catch {
        this.confirmLoading = false
      }
    },
    cancelHandle() {
      if (this.isReject) {
        this.$refs.approvalForm.clearValidate()
      }
      this.$emit('close')
    },
    confirmHandle() {
      if (this.callbackFn) {
        this.callbackFn()
        this.cancelHandle()
        this.$emit('refreash')
        return
      }

      if (this.isReject) {
        this.$refs.approvalForm.validate((valid) => {
          if (valid) {
            this.approvalTaskSubmit()
          }
        })
        return
      }
      this.approvalTaskSubmit()
    },
  },
}
</script>
